import { ref } from 'vue';

type Theme = 'light' | 'dark';

// Función para obtener el tema inicial
const getInitialTheme = (): Theme => {
  // Primero intentamos obtener del localStorage
  const savedTheme = localStorage.getItem('theme') as Theme | null;
  
  if (savedTheme) {
    return savedTheme;
  }
  
  // Si no hay tema guardado, detectamos la preferencia del sistema
  if (typeof window !== 'undefined') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
  }
  
  return 'light';
};

// Inicializar el tema inmediatamente
const initialTheme = getInitialTheme();
document.documentElement.classList.add(initialTheme);

// Singleton: ref compartido entre todos los llamadores de useTheme()
const theme = ref<Theme>(initialTheme);

const applyTheme = (newTheme: Theme) => {
  document.documentElement.classList.remove('light', 'dark');
  document.documentElement.classList.add(newTheme);
  localStorage.setItem('theme', newTheme);
  theme.value = newTheme;
};

// Observar cambios en la preferencia del sistema (una sola vez, nivel módulo)
if (typeof window !== 'undefined') {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  mediaQuery.addEventListener('change', e => {
    if (!localStorage.getItem('theme')) {
      applyTheme(e.matches ? 'dark' : 'light');
    }
  });
}

export function useTheme() {
  const toggleTheme = () => {
    applyTheme(theme.value === 'light' ? 'dark' : 'light');
  };

  return {
    theme,
    toggleTheme,
  };
}